import { JsonEditor } from './jsoneditor';
import { useRef, useEffect } from 'react';

interface IValueEditorProps {
    value: object
}

function ValueEditor({ value }: IValueEditorProps) {

    const editor = useRef<any>(null);

    useEffect(() => {
        if (editor.current !== null) {
            editor.current.set(value);
        }
    }, [value])

    const setRef = (instance: any) => {
        if (instance) {
            editor.current = instance.jsonEditor;
        } else {
            editor.current = null;
        }
    };

    return (
        <JsonEditor ref={setRef} value={value} mode="view" navigationBar={false} search={false} statusBar={false} mainMenuBar={false} />
    );
}

export default ValueEditor;
